module.exports = __webpack_public_path__ + "img/seedproductadminhome.e293b5e0.png";